import type { IValidationField } from '../types';
import * as yup from 'yup';
import { t } from 'i18next';
import { PRODUCT_MIN_QUANTITY } from 'appConstants';

export default function packagedItemQty({ label = '' }: IValidationField) {
  return (
    yup
      .number()
      .label(label)
      .min(PRODUCT_MIN_QUANTITY)
      //.max(PRODUCT_MAX_QUANTITY) TODO: Confirm max quantity
      .required()
      .typeError(`${label} ${t('errors.number')}`)
      .test({
        name: 'valid_quantity',
        test: (packagedItemQty, context) => {
          const {
            parent: { productData: { packageIsSolid = false, packageDescription = '' } = {} } = {},
            path,
          } = context;

          if (packagedItemQty && packageIsSolid && packageDescription) {
            const packageSize = Number(packageDescription.replace(/\D/g, '') || 0);
            const quantity = Number(packagedItemQty);

            if (packageSize && quantity) {
              const denominator = packageSize / 1000;
              if (Number((quantity / denominator).toFixed(6)) % 1 !== 0) {
                const suggestedValue = Number(
                  (Math.ceil((quantity * 1000) / packageSize) * denominator).toFixed(1),
                );

                return context.createError({
                  message: t('errors.divisionBy', {
                    label,
                    denominator,
                    suggestedValue,
                  }),
                  path,
                });
              }
            }
          }

          return true;
        },
      })
  );
}
